export default __webpack_public_path__ + "static/media/Consolas.dac6c0a2.woff";